<template>
    <div class="row block-warning">
        <div
            class="small-12 columns"
            v-html="value"
        />
        <div class="small-12 columns">
            <hr>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlockWarning',
    props: {
        value: {
            type: String,
            default() {
                return null;
            }
        }
    }
};
</script>
